import React from 'react';

import PositionedGoodyHOC from '../PositionedGoodyHOC';
import { POSITIONED_GOODY_REFS } from '../../../../constants';

export default class Beanie extends PositionedGoodyHOC {
	// 6
	render() {
		const style = {
			st36: {
				fill: '#987FEF',
			},
			st9: {
				fill: '#EFEFEF',
			},
			st53: {
				fill: '#836EEA',
			},
		};
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} style={style.st144} cx="38.914917" cy="83.4989471" />
				<path style={style.st36} d="M74.5371704,75.6489105c0-29.8233795-15.6700325-54-35-54s-35,24.1766224-35,54" />
				<path style={style.st9} d="M41.7727814,1.477563l0.0000076-0.0000108c1.5273018-2.2293291,5.0192604-1.0947227,4.9445114,1.6065693
					v0.0000131c-0.052681,1.9037232,1.8230209,3.2665019,3.6172905,2.6281166l0.0000114-0.0000043
					c2.5459824-0.905838,4.7041321,2.0646,3.0558777,4.2060528l-0.0000076,0.0000105
					c-1.161602,1.5091801-0.4451447,3.7142019,1.3816833,4.2523823l0.0000114,0.0000038
					c2.5921822,0.7636518,2.5921822,4.4353161,0,5.198967l-0.0000114,0.0000038
					c-1.826828,0.5381813-2.5432854,2.7432022-1.3816833,4.2523823l0.0000076,0.0000114
					c1.6482544,2.1414528-0.5098953,5.1118908-3.0558777,4.2060528l-0.0000114-0.0000057
					c-1.7942696-0.6383839-3.6699715,0.7243938-3.6172905,2.6281166v0.0000134
					c0.074749,2.7012939-3.4172096,3.8358994-4.9445114,1.6065712l-0.0000076-0.0000114
					c-1.0763626-1.5711098-3.3948593-1.5711098-4.4712219,0l-0.0000076,0.0000114
					c-1.5273018,2.2293282-5.0192604,1.0947227-4.9445114-1.6065712v-0.0000134
					c0.052681-1.9037228-1.8230209-3.2665005-3.6172905-2.6281166l-0.0000134,0.0000057
					c-2.5459805,0.905838-4.7041302-2.0646-3.0558758-4.2060528l0.0000076-0.0000114
					c1.1616001-1.5091801,0.4451447-3.714201-1.3816814-4.2523823l-0.0000134-0.0000038
					c-2.5921803-0.7636509-2.5921803-4.4353151,0-5.198967l0.0000134-0.0000038
					c1.8268261-0.5381804,2.5432816-2.7432022,1.3816814-4.2523823l-0.0000076-0.0000105
					c-1.6482544-2.1414528,0.5098953-5.1118908,3.0558758-4.2060528l0.0000134,0.0000043
					c1.7942696,0.6383853,3.6699715-0.7243934,3.6172905-2.6281166V3.0841215
					c-0.074749-2.701292,3.4172096-3.8358984,4.9445114-1.6065693l0.0000076,0.0000108
					C38.3779221,3.0486724,40.6964188,3.0486724,41.7727814,1.477563z" />
				<path style={style.st53} d="M73.9721985,88.7065277H6.0278015c-3.1982346,0-5.8149719-2.6167374-5.8149719-5.8149719V65.9638824
					c0-3.1982384,2.6167374-5.8149757,5.8149719-5.8149757h67.944397c3.1982346,0,5.8149719,2.6167374,5.8149719,5.8149757v16.9276733
					C79.7871704,86.0897903,77.170433,88.7065277,73.9721985,88.7065277z" />
				<path style={style.st36} d="M36.5371704,23.3989086c-1,0-1,3,0,3C38.5371704,26.3989086,38.5371704,23.3989086,36.5371704,23.3989086z
					" />
				<path style={style.st36} d="M28.5371704,8.0392542c-1,0-1,2.6534348,0,2.6534348
					C30.5371704,10.6926889,30.5371704,8.0392542,28.5371704,8.0392542z" />
				<path style={style.st36} d="M31.5371704,16.2206783c-2,0-2,2.6534348,0,2.6534348S33.5371704,16.2206783,31.5371704,16.2206783z" />
				<path style={style.st36} d="M40.5371704,6.9336562c-2,0-2,2.6534352,0,2.6534352S42.5371704,6.9336562,40.5371704,6.9336562z" />
				<path style={style.st36} d="M49.5371704,14.0094824c-2,0-2,2.6534357,0,2.6534357
					C50.5371704,16.6629181,50.5371704,14.0094824,49.5371704,14.0094824z" />
				<path style={style.st36} d="M50.5371704,22.1489086c-1.9304199,0-1.9335938,3,0,3
					C52.4675903,25.1489086,52.4707642,22.1489086,50.5371704,22.1489086z" />
				<path style={style.st53} d="M37.5371704,9.8082104c-1,0-1,2.6534348,0,2.6534348
					C39.5371704,12.4616451,39.5371704,9.8082104,37.5371704,9.8082104z" />
				<path style={style.st53} d="M35.5371704,2.511265c-1,0-1,2.6534345,0,2.6534345S36.5371704,2.511265,35.5371704,2.511265z" />
				<path style={style.st53} d="M26.5371704,22.8989086c-2,0-2,3,0,3S28.5371704,22.8989086,26.5371704,22.8989086z" />
				<path style={style.st53} d="M36.5371704,16.2206783c-1,0-1,2.6534348,0,2.6534348
					C38.5371704,18.8741131,38.5371704,16.2206783,36.5371704,16.2206783z" />
				<path style={style.st53} d="M44.5371704,26.8989086c-1,0-1,3,0,3C46.5371704,29.8989086,46.5371704,26.8989086,44.5371704,26.8989086z
					" />
				<path style={style.st53} d="M45.5371704,15.5573196c-2,0-2,2.6534348,0,2.6534348S47.5371704,15.5573196,45.5371704,15.5573196z" />
				<path style={style.st53} d="M50.5371704,7.3758955c-1,0-1,2.6534348,0,2.6534348S51.5371704,7.3758955,50.5371704,7.3758955z" />
			</g>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Hat/Beanie.js